import { render, staticRenderFns } from "./EditEmailTemplate.vue?vue&type=template&id=42947458&scoped=true"
import script from "./EditEmailTemplate.vue?vue&type=script&lang=js"
export * from "./EditEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditEmailTemplate.vue?vue&type=style&index=0&id=42947458&prod&lang=scss&scoped=true"
import style1 from "./EditEmailTemplate.vue?vue&type=style&index=1&id=42947458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42947458",
  null
  
)

export default component.exports